import React from 'react';
import { PageHeader } from '@components/Shared/PageHeader';
import { LawyerCorrespondenceContainer } from '@containers/LawyerCorrespondenceContainer';
import { PageContainer } from './LawyerCorrespondence.styles';

export default function LawyerCorrespondence() {
  return (
    <PageContainer>
      <PageHeader 
        title="Lawyer Correspondence" 
        description="talk to lawyers"
      />
      <LawyerCorrespondenceContainer />
    </PageContainer>
  );
}